/** Same ranking as protego-frontend / protego-landing. */
const PLAN_RANK = {
  none: 0,
  audit: 1,
  poa: 2,
  monitor: 3,
  guard: 4,
};

/**
 * @returns {'guest'|'current'|'included'|'upgrade'}
 */
export function planAccessForProduct(planId, user) {
  if (!user?.plan_active) {
    return user ? 'upgrade' : 'guest';
  }

  const current = user.plan || 'none';
  const currentRank = PLAN_RANK[current] ?? 0;
  const targetRank = PLAN_RANK[planId] ?? 0;

  if (current === planId) return 'current';
  if (currentRank >= targetRank) return 'included';
  return 'upgrade';
}

export function ctaLabelForAccess(access, defaultLabel) {
  if (access === 'current') return 'Current plan';
  if (access === 'included') return 'Included in your plan';
  return defaultLabel;
}
